/* eslint-disable function-paren-newline */
import Loadable from 'react-loadable';
import { Loading } from 'utilsModule/components';

export default Loadable({
  loader: () => import(
    /* webpackChunkName: 'onboard' */
    /* webpackPrefetch: true */
    '../layouts',
  ),
  loading: Loading,
});
